module.exports = __webpack_public_path__ + "static/img/QR_wechat_person.de20d610.png";